import { PLACEHOLDER } from 'constant';
export const currencyOrderPreference = [
    'USD',
    'EUR',
    'GBP',
    'CAD',
    'AUD',
    'JPY',
    'INR',
    'NZD',
    'CHF',
    'SGD',
    'HKD',
    'CNY',
    'MXN'
];
export const getCurrencyLabel = ({ currencyCode, currencyName, currencySymbol }, showSymbol = true)=>`${currencyCode} ${PLACEHOLDER} ${currencyName} ${showSymbol ? `(${currencySymbol})` : ''}`;
export const asCurrencyOption = (currency)=>({
        label: getCurrencyLabel(currency),
        value: currency.currencyCode,
        extra: currency
    });
export const getCurrencyListFromCurrencyMappingList = (currencies)=>currencies.map(({ currency })=>currency);
export const selectableCurrencyOptions = (currencies)=>currencies.map(asCurrencyOption);
